import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 15" {...props}>
    <g fill="currentColor" fill-rule="evenodd">
      <path d="M4.503 7.642V6.398c.004-.949.631-1.719 1.565-1.873a1.86 1.86 0 0 1 2.154 1.52c.022.12.03.246.03.37.003.817.003 1.634 0 2.452-.001.101.025.134.129.133.422-.006.845.003 1.267-.004.391-.007.655.158.829.514.469.96.953 1.912 1.43 2.868.224.45.03.935-.429 1.085a.751.751 0 0 1-.896-.376c-.405-.81-.812-1.619-1.211-2.432-.058-.117-.122-.16-.255-.159-1.007.006-2.014.004-3.022.003-.365 0-.709-.083-1-.315-.37-.295-.585-.676-.59-1.158-.005-.462-.002-.923-.002-1.384h.001Z" />
      <path d="M0 10.494C.043 9.02.638 7.82 1.808 6.914c.332-.256.777-.192 1.047.137a.74.74 0 0 1-.087 1.008c-.172.162-.362.308-.517.484-.621.706-.861 1.535-.699 2.459.2 1.13.857 1.906 1.925 2.314 1.22.467 2.64.03 3.413-1.024a.756.756 0 0 1 1.033-.192.728.728 0 0 1 .21 1.023c-.357.528-.83.937-1.377 1.261a4.35 4.35 0 0 1-2.676.595C2.182 14.803.727 13.461.227 11.89A4.643 4.643 0 0 1 0 10.494m6.752-7.498a1.494 1.494 0 0 1-1.5-1.511A1.497 1.497 0 0 1 6.756 0c.839.003 1.501.67 1.498 1.511a1.497 1.497 0 0 1-1.501 1.485" />
    </g>
  </svg>
);
export const MotorImparedIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
